export default __webpack_public_path__ + "static/media/newInvoiceEduc.860fafd4.png";